import { call, put, takeLatest } from 'redux-saga/effects'
import { SubmissionError } from 'redux-form'
import { errorHandler } from '../../../core/helpers/errorHelpers'
import {
  fetchSkillsSuccess,
  fetchSkillsError,
  updateSkillsSuccess,
  updateSkillsError,
  searchSkillsSuccess,
  searchSkillsError,
  FETCH,
  SEARCH,
  UPDATE,
} from '../modules/skills'
import { fetchSkills, updateSkills, searchSkills } from '../api'

function* fetchSkillsSaga({ payload }) {
  try {
    const response = yield fetchSkills(payload.id)
    yield put(fetchSkillsSuccess(response))
  } catch (err) {
    const { error } = yield call(errorHandler, err)
    yield put(fetchSkillsError(error))
  }
}

function* updateSkillsSaga({ meta, payload }) {
  try {
    const response = yield updateSkills(payload.id, payload.data)
    yield put(updateSkillsSuccess(response))
    yield call(meta.resolve)
  } catch (err) {
    const { error } = yield call(errorHandler, err)
    yield put(updateSkillsError(error))
    yield call(meta.reject, new SubmissionError({ _error: error }))
  }
}

function* searchSkillsSaga({ payload }) {
  try {
    const response = yield searchSkills(payload.text)
    yield put(searchSkillsSuccess(response))
  } catch (err) {
    const { error } = yield call(errorHandler, err)
    yield put(searchSkillsError(error))
  }
}

export default function* watchSkillsSaga() {
  yield takeLatest(FETCH, fetchSkillsSaga)
  yield takeLatest(SEARCH, searchSkillsSaga)
  yield takeLatest(UPDATE, updateSkillsSaga)
}
